import { c as _c } from "react/compiler-runtime";
import { Modal, ModalSizeEnum, PrimaryButton } from '@systemeio/ui';
import React from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface SplitTestPreviewStepModalProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  stepAPreviewLink: string;
  stepBPreviewLink: string;
}
function SplitTestPreviewStepModal(t0) {
  const $ = _c(26);
  const {
    open,
    setOpen,
    stepAPreviewLink,
    stepBPreviewLink
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== setOpen) {
    t1 = () => setOpen(false);
    $[0] = setOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("dashboard.funnel.configuration.common.preview_running_split_test_title");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("dashboard.funnel.configuration.common.preview_running_split_test_page_a");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <span className="text-start">{t3}</span>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== stepAPreviewLink || $[9] !== t4) {
    t5 = <PrimaryButton as={LinkWithoutPrefetch} className="!justify-start" href={stepAPreviewLink} target="_blank" data-test-element="view-funnel-step-a-button">{t4}</PrimaryButton>;
    $[8] = stepAPreviewLink;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("dashboard.funnel.configuration.common.preview_running_split_test_page_b");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <span className="text-start">{t6}</span>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== stepBPreviewLink || $[16] !== t7) {
    t8 = <PrimaryButton as={LinkWithoutPrefetch} className="!justify-start" href={stepBPreviewLink} target="_blank" data-test-element="view-funnel-step-b-button">{t7}</PrimaryButton>;
    $[15] = stepBPreviewLink;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t5 || $[19] !== t8) {
    t9 = <div className="flex justify-center gap-4">{t5}{t8}</div>;
    $[18] = t5;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== open || $[22] !== t1 || $[23] !== t2 || $[24] !== t9) {
    t10 = <Modal opened={open} size={ModalSizeEnum.medium} onClose={t1} title={t2}>{t9}</Modal>;
    $[21] = open;
    $[22] = t1;
    $[23] = t2;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}
export default SplitTestPreviewStepModal;